/**
 * Artwork Approval Component
 * Handles validation and UX for artwork approval section
 */
class ArtworkApproval {
  constructor(element) {
    this.element = element;
    this.checkbox = element.querySelector('.artwork-approval__checkbox-input');
    this.form = document.querySelector(`[id="${this.checkbox.getAttribute('form')}"]`) || 
               this.checkbox.closest('form');
    
    this.init();
  }

  init() {
    if (this.checkbox && this.form) {
      this.bindEvents();
      this.setInitialState();
    }
  }

  bindEvents() {
    // Prevent form submission if checkbox is not checked
    this.form.addEventListener('submit', this.validateForm.bind(this));
    
    // Add visual feedback on checkbox change
    this.checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
    
    // Add keyboard support for better accessibility
    this.checkbox.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  setInitialState() {
    // Ensure the form cannot be submitted initially if checkbox is not checked
    this.updateFormState();
  }

  validateForm(event) {
    if (!this.checkbox.checked) {
      event.preventDefault();
      this.showValidationError();
      this.checkbox.focus();
      return false;
    }
    return true;
  }

  handleCheckboxChange() {
    this.updateFormState();
    if (this.checkbox.checked) {
      this.hideValidationError();
    }
  }

  handleKeyDown(event) {
    // Allow spacebar to toggle checkbox
    if (event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
      this.checkbox.checked = !this.checkbox.checked;
      this.checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  updateFormState() {
    const submitButtons = this.form.querySelectorAll('[type="submit"], .btn--add-to-cart');
    
    submitButtons.forEach(button => {
      if (this.checkbox.checked) {
        button.removeAttribute('disabled');
        button.classList.remove('btn--disabled');
      } else {
        button.setAttribute('disabled', 'disabled');
        button.classList.add('btn--disabled');
      }
    });
  }

  showValidationError() {
    // Remove any existing error message
    this.hideValidationError();
    
    // Create error message
    const errorMessage = document.createElement('div');
    errorMessage.className = 'artwork-approval__error-message';
    errorMessage.textContent = 'Please confirm that you understand your file will be printed exactly as submitted.';
    errorMessage.setAttribute('role', 'alert');
    errorMessage.setAttribute('aria-live', 'polite');
    
    // Insert error message after checkbox
    const checkboxContainer = this.checkbox.closest('.artwork-approval__checkbox');
    checkboxContainer.parentNode.insertBefore(errorMessage, checkboxContainer.nextSibling);
    
    // Add error styling
    this.checkbox.classList.add('error');
  }

  hideValidationError() {
    const errorMessage = this.element.querySelector('.artwork-approval__error-message');
    if (errorMessage) {
      errorMessage.remove();
    }
    this.checkbox.classList.remove('error');
  }
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const artworkApprovalElements = document.querySelectorAll('.product__artwork-approval');
  artworkApprovalElements.forEach(element => {
    new ArtworkApproval(element);
  });
});

// Re-initialize for dynamic content (e.g., AJAX product forms)
document.addEventListener('shopify:section:load', (event) => {
  const artworkApprovalElements = event.target.querySelectorAll('.product__artwork-approval');
  artworkApprovalElements.forEach(element => {
    new ArtworkApproval(element);
  });
});
